import { zodResolver } from "@hookform/resolvers/zod";
import {
  useInvestorClassRetrieveSuspense,
  useInvestorClassUpdate,
} from "gen/endpoints/investor-class/investor-class";
import { InvestorClassReadData } from "gen/model/investorClassReadData";
import { investorClassUpdateBody } from "gen/schemas/investor-class/investor-class";
import { DefaultValues, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormTextArea } from "shared/components/input/text/TextArea";
import { FormTextInput } from "shared/components/input/text/TextInput";

export const CommitmentClassFormFields: React.FC = () => {
  const { t } = useTranslation(["commitmentClass", "common"]);
  return (
    <>
      <FormTextInput
        name="name"
        title={t("commitmentClass:createModal.name")}
      />
      <FormTextArea name="notes" title={t("common:notesOptional")} />
    </>
  );
};

export const useCommitmentClassEditForm = (
  fundFamilyId: string,
  investorClassId: string,
) => {
  const { t } = useTranslation(["commitmentClass"]);

  const { data: investorClassData } = useInvestorClassRetrieveSuspense(
    fundFamilyId,
    investorClassId,
  );

  const { mutateAsync: editInvestorClass } = useInvestorClassUpdate();

  const form = useForm<InvestorClassReadData>({
    resolver: zodResolver(investorClassUpdateBody),
    defaultValues: investorClassData as DefaultValues<InvestorClassReadData>,
  });

  return {
    form,
    onSubmit: async (data: InvestorClassReadData) =>
      await editInvestorClass({
        fundFamilyId,
        investorClassId,
        data,
      }),
    successMessage: t("commitmentClass:edited"),
  };
};
